import { useCallback } from 'react';
import { appendParams, finalizeUrl, getDefaultDeeplink } from '../../utils';
import { useIsInFragmentScreens, useOpenDeeplink } from '../../../../hooks';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';

/**
 * fragment(네이티브 바텀탭 위) 컨텍스트는 RN push 시 탭바가 남아 딥링크로 풀스크린을 띄우고,
 * 순수 RN 탭에서는 root Stack push로 풀스크린이 된다.
 */
export const useMoveToLikeMarketList = () => {
  const { openDeeplink } = useOpenDeeplink();
  const isInFragmentScreens = useIsInFragmentScreens();
  const navigation = useRootStackNavigation();

  return useCallback(() => {
    if (isInFragmentScreens) {
      const url = getDefaultDeeplink();
      appendParams(url, 'screen', 'LikeMarketList');
      openDeeplink(finalizeUrl(url));
      return;
    }
    navigation.push('LikeMarketList', {});
  }, [isInFragmentScreens, openDeeplink, navigation]);
};
